// Copyright 2017-2022 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert } from '@polkadot/util';
import { isReady, waitReady } from '@polkadot/wasm-crypto';
export var cryptoIsReady = isReady;
export function cryptoWaitReady() {
  return waitReady().then(function () {
    assert(isReady(), 'Unable to initialize @polkadot/util-crypto');
    return true;
  }).catch(function () {
    return false;
  });
}